import React, { Dispatch, useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import moment from 'moment';
import { FormControl } from '../../ui/FormControlGrey';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';
import classes from './changeEmployeeDialog.module.scss';
import { NumberField } from '../../ui/NumberMask';

import { useStaff } from '../../../hooks/entityHooks';
import { CreateStaff } from '../../../types/subdivision';

type FormikValues = {
  name: string;
  surname: string;
  middleName: string;
  dateBirth: string;
  upn: string;
  email: string;
  inPhone: string;
  mPhone: string;
  cPhone: string;
  position: string;
  tNumber: string;
  login: string;
  domen: string;
  dateOfJobTitle: string;
  dateOfFired: string;
  dateofAdmission: string;
};

type LogsInfo = {
  id?: number;
  type?: number;
};

type props = {
  open: boolean;
  setOpen: Dispatch<boolean>;
  logsInfo: LogsInfo;
  handleUpdateEntity(id: number, type: number): Promise<void>;
};
export const ChangeUserDialog = ({
  open,
  setOpen,
  logsInfo,
  handleUpdateEntity,
}: props) => {
  const {
    getEntity: getStaff,
    entity: info,
    fullUpdateEntity: update,
  } = useStaff();

  const { id } = logsInfo;

  const [sex, setSex] = useState('male');
  const [date, setDate] = useState('2021-01-01');
  const [currentIsKarmaUser, setIsKarmUser] = useState(false);

  useEffect(() => {
    if (id) {
      if (logsInfo.type === 3) {
        getStaff(id);
      }
    }
  }, [id, open]);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSex((event.target as HTMLInputElement).value);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const useStyles = makeStyles({
    save: {
      background: '#FF7221',
      borderRadius: 0,
      color: 'white',
      maxWidth: 220,
      width: '100%',
      fontSize: 16,
      fontWeight: 550,
      textTransform: 'none',
      '&:hover, &:focus': {
        background: '#C8524D',
      },
      fontFamily: 'HelveticaNeueCyr',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 18px',
    },
    cancel: {
      background: 'none',
      borderRadius: 0,
      color: '#FF7221',
      maxWidth: 220,
      width: '100%',
      fontSize: 16,
      textTransform: 'none',
      '&:hover, &:focus': {
        background: '#FF7221',
        color: 'white',
      },
      fontFamily: 'HelveticaNeueCyr',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 18px',
      border: '1px solid #FF7221',
    },
    radioGroup: {
      display: 'flex',
    },
  });

  const {
    handleSubmit,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
    setValues,
    setFieldTouched,
    resetForm,
  } = useFormik<FormikValues>({
    initialValues: {
      email: '',
      dateofAdmission: '',
      dateOfFired: '',
      domen: '',
      login: '',
      tNumber: '',
      position: '',
      cPhone: '',
      mPhone: '',
      inPhone: '',
      upn: '',
      dateBirth: '',
      middleName: '',
      surname: '',
      name: '',
      dateOfJobTitle: '',
    },
    onSubmit: () => {
      const phones = [];
      if (values.mPhone.length) {
        phones.push({
          tel: values.mPhone,
          type: 'mobile',
        });
      }
      if (values.inPhone.length) {
        phones.push({
          tel: values.inPhone,
          type: 'internal',
        });
      }
      if (values.cPhone.length) {
        phones.push({
          tel: values.cPhone,
          type: 'city',
        });
      }
      const updateStaff: CreateStaff = {
        id: id || 0,
        isKarmaUser: currentIsKarmaUser,
        gender: sex === 'female',
        email: values.email,
        AdDomain: values.domen,
        lastname: values.surname,
        firstname: values.name,
        middlename: values.middleName,
        DOB: new Date(values.dateBirth),
        jobTitle: values.position,
        JOBnumber: values.tNumber,
        SamAccountName: values.login,
        UPN: values.upn,
        DateOfJobTitle: new Date(values.dateOfJobTitle),
        DateOfFired: new Date(values.dateOfFired),
        DateofAdmission: new Date(values.dateofAdmission),
        phones,
      };
      const sand = {
        employee: updateStaff,
      };
      const response = update(sand);
      response.then(() => {
        if (id) {
          getStaff(id);
          handleUpdateEntity(id, 3);
        }

        resetForm();
        handleClose();
      });
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Обязательно для заполнения'),
      surname: Yup.string().required('Обязательно для заполнения'),
      middleName: Yup.string().required('Обязательно для заполнения'),
      dateBirth: Yup.string().notRequired(),
      upn: Yup.string().required('Обязательно для заполнения'),
      email: Yup.string()
        .email('Это не email')
        .required('Обязательно для заполнения'),
      inPhone: Yup.string().notRequired(),
      mPhone: Yup.string().notRequired(),
      cPhone: Yup.string().notRequired(),
      position: Yup.string().required('Обязательно для заполнения'),
      tNumber: Yup.string().required('Обязательно для заполнения'),
      login: Yup.string().required('Обязательно для заполнения'),
      domen: Yup.string().required('Обязательно для заполнения'),
      dateOfJobTitle: Yup.string().notRequired(),
      dateOfFired: Yup.string().notRequired(),
      dateofAdmission: Yup.string().notRequired(),
    }),
  });

  useEffect(() => {
    if (info) {
      const {
        AdDomain,
        DateofAdmission,
        DateOfFired,
        DateOfJobTitle,
        DOB,
        email,
        firstname,
        gender,
        JOBnumber,
        jobTitle,
        lastname,
        middlename,
        phones,
        SamAccountName,
        UPN,
        isKarmaUser,
      } = info;

      setIsKarmUser(isKarmaUser);
      const dob = moment(DOB);
      const dateofAdmission = moment(DateofAdmission);
      const dateOfJobTitle = moment(DateOfJobTitle);
      const dateOfFired = moment(DateOfFired);

      let internal = '';
      let mobile = '';
      let city = '';

      if (phones.find((el) => el.type === 'internal')) {
        // @ts-ignore
        internal = phones.find((el) => el.type === 'internal').tel;
      }
      if (phones.find((el) => el.type === 'mobile')) {
        // @ts-ignore
        mobile = phones.find((el) => el.type === 'mobile').tel;
      }
      if (phones.find((el) => el.type === 'city')) {
        // @ts-ignore
        city = phones.find((el) => el.type === 'city').tel;
      }
      if (gender) {
        setSex('female');
      } else {
        setSex('male');
      }
      setDate(
        dateofAdmission.isValid()
          ? `${dateofAdmission.format('YYYY-MM-DD')}`
          : '2021-01-01',
      );

      setValues({
        dateofAdmission: dateofAdmission.isValid()
          ? `${dateofAdmission.format('YYYY-MM-DD')}`
          : '',
        name: firstname,
        surname: lastname,
        middleName: middlename,
        dateBirth: dob.isValid() ? `${dob.format('YYYY-MM-DD')}` : '',
        upn: UPN,
        inPhone: internal,
        mPhone: mobile,
        cPhone: city,
        position: jobTitle,
        tNumber: JOBnumber,
        login: SamAccountName,
        domen: AdDomain,
        email,
        dateOfFired: dateOfFired.isValid()
          ? `${dateOfFired.format('YYYY-MM-DD')}`
          : '',
        dateOfJobTitle: dateOfJobTitle.isValid()
          ? `${dateOfJobTitle.format('YYYY-MM-DD')}`
          : '',
      });
    }
  }, [info]);
  const style = useStyles();
  const [focus, setFocus] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <form className={classes.form} onSubmit={handleSubmit}>
        <DialogTitle>
          <div className={classes.form__dialogTitle}>
            <span>Редактирование сотрудника</span>
            <div
              className={classes.close}
              onMouseOver={(e) => setFocus(true)}
              onMouseOut={(e) => setFocus(false)}
              onClick={(e) => setOpen(false)}
            >
              {focus ? <FillClose /> : <Close />}
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Имя</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Имя"
                type="text"
                name="name"
                value={values.name}
                onChange={(e) => setFieldValue('name', e.target.value)}
                error={Boolean(errors?.name && touched?.name)}
                errorMessage={errors?.name}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Фамилия</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Фамилия"
                type="text"
                name="surname"
                value={values.surname}
                onChange={(e) => setFieldValue('surname', e.target.value)}
                error={Boolean(errors?.surname && touched?.surname)}
                errorMessage={errors?.surname}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>
          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Отчество</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Отчество"
                type="text"
                name="middleName"
                value={values.middleName}
                onChange={(e) => setFieldValue('middleName', e.target.value)}
                error={Boolean(errors?.middleName && touched?.middleName)}
                errorMessage={errors?.middleName}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>
          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Пол</p>
            </div>

            <div className={classes.form__row__input}>
              <RadioGroup
                row
                aria-label="gender"
                name="gender1"
                value={sex}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="male"
                  control={<Radio />}
                  label="Мужской"
                />
                <FormControlLabel
                  value="female"
                  control={<Radio />}
                  label="Женский"
                />
              </RadioGroup>
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Дата рождения</p>
            </div>

            <div className={classes.form__row__inputDate}>
              <FormControl
                placeholder="Дата рождения"
                type="date"
                name="middleName"
                value={values.dateBirth}
                onChange={(e) => setFieldValue('dateBirth', e.target.value)}
                error={Boolean(errors?.dateBirth && touched?.dateBirth)}
                // errorMessage={errors?.dateBirth}
                onBlur={handleBlur}
                inputProps={{ min: '1921-01-01', max: '2021-01-01' }}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>UPN</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="upn"
                type="text"
                name="upn"
                value={values.upn}
                onChange={(e) => setFieldValue('upn', e.target.value)}
                error={Boolean(errors?.upn && touched?.upn)}
                errorMessage={errors?.upn}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>
          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Email</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Email"
                type="text"
                name="email"
                value={values.email}
                onChange={(e) => setFieldValue('email', e.target.value)}
                error={Boolean(errors?.email && touched?.email)}
                errorMessage={errors?.email}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>
          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Внутренний телефон</p>
            </div>

            <div className={classes.form__row__input}>
              <NumberField
                placeholder="Внутренний телефон"
                type="text"
                name="inPhone"
                value={values.inPhone}
                onChange={(e) => setFieldValue('inPhone', e.target.value)}
                error={Boolean(errors?.inPhone && touched?.inPhone)}
                errorMessage={errors?.inPhone}
                onBlur={handleBlur}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Мобильный телефон</p>
            </div>

            <div className={classes.form__row__input}>
              <NumberField
                placeholder="Мобильный телефон"
                type="text"
                name="mPhone"
                value={values.mPhone}
                onChange={(e) => setFieldValue('mPhone', e.target.value)}
                error={Boolean(errors?.mPhone && touched?.mPhone)}
                errorMessage={errors?.mPhone}
                onBlur={handleBlur}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Городской телефон</p>
            </div>

            <div className={classes.form__row__input}>
              <NumberField
                placeholder="Городской телефон"
                type="text"
                name="cPhone"
                value={values.cPhone}
                onChange={(e) => setFieldValue('cPhone', e.target.value)}
                error={Boolean(errors?.cPhone && touched?.cPhone)}
                errorMessage={errors?.cPhone}
                onBlur={handleBlur}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Должность</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Должность"
                type="text"
                name="position"
                value={values.position}
                onChange={(e) => setFieldValue('position', e.target.value)}
                error={Boolean(errors?.position && touched?.position)}
                errorMessage={errors?.position}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Табельный номер</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Табельный номер"
                type="text"
                name="tNumber"
                value={values.tNumber}
                onChange={(e) => setFieldValue('tNumber', e.target.value)}
                error={Boolean(errors?.tNumber && touched?.tNumber)}
                errorMessage={errors?.tNumber}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Логин</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Логин"
                type="text"
                name="login"
                value={values.login}
                onChange={(e) => setFieldValue('login', e.target.value)}
                error={Boolean(errors?.login && touched?.login)}
                errorMessage={errors?.login}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Домен</p>
            </div>

            <div className={classes.form__row__input}>
              <FormControl
                placeholder="Домен"
                type="text"
                name="domen"
                value={values.domen}
                onChange={(e) => setFieldValue('domen', e.target.value)}
                error={Boolean(errors?.domen && touched?.domen)}
                errorMessage={errors?.domen}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Дата вступления в должность</p>
            </div>

            <div className={classes.form__row__inputDate}>
              <FormControl
                placeholder="Дата вступления в должность"
                type="date"
                name="dateOfJobTitle"
                value={values.dateOfJobTitle}
                onChange={(e) =>
                  setFieldValue('dateOfJobTitle', e.target.value)
                }
                error={Boolean(
                  errors?.dateOfJobTitle && touched?.dateOfJobTitle,
                )}
                // errorMessage={errors?.entryDate}
                inputProps={{ min: date }}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Дата увольнения</p>
            </div>

            <div className={classes.form__row__inputDate}>
              <FormControl
                placeholder="Дата увольнения"
                type="date"
                name="dismissalDate"
                value={values.dateOfFired}
                onChange={(e) => setFieldValue('dateOfFired', e.target.value)}
                error={Boolean(errors?.dateOfFired && touched?.dateOfFired)}
                // errorMessage={errors?.dismissalDate}
                inputProps={{ min: date }}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>

          <div className={classes.form__row}>
            <div className={classes.form__row__title}>
              <p>Дата приема на работу</p>
            </div>

            <div className={classes.form__row__inputDate}>
              <FormControl
                placeholder="Дата приема на работу"
                type="date"
                name="dateofAdmission"
                value={values.dateofAdmission}
                onChange={(e) => {
                  setFieldValue('dateofAdmission', e.target.value);
                  setDate(e.target.value);
                }}
                error={Boolean(
                  errors?.dateofAdmission && touched?.dateofAdmission,
                )}
                // errorMessage={errors?.startDate}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>
        </DialogContent>

        <div className={classes.form__row__buttons}>
          <Button
            className={style.cancel}
            onClick={handleClose}
            color="primary"
          >
            Отмена
          </Button>

          <Button
            className={style.save}
            // onClick={handleClose}
            type="submit"
            color="primary"
          >
            Сохранить изменения
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
